import { useState } from 'react'
import { Layers } from 'lucide-react'

import { BatchDialog } from '@/components/batch/batch-dialog'
import { Button } from '@/components/ui/button'
import { useActivityStore } from '@/store/activity-store'

/**
 * Toolbar "Batch" button (M7) -- only rendered once at least one
 * activity is ticked in the sidebar (per the "no placeholder UI" rule:
 * batch operations are meaningless with nothing selected for them).
 */
export function BatchButton() {
  const batchCount = useActivityStore((s) => s.batchSelectedIds.length)
  const [open, setOpen] = useState(false)

  if (batchCount === 0) return null

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        aria-label={`Batch (${batchCount})`}
        onClick={() => setOpen(true)}
      >
        <Layers className="h-3.5 w-3.5" aria-hidden="true" />
        {/* Just the icon and count on phones. */}
        <span className="max-sm:hidden">Batch</span>({batchCount})
      </Button>
      <BatchDialog open={open} onOpenChange={setOpen} />
    </>
  )
}
